<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="far fa-comments"></i>
          Ayuda
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button right variant="primary" @click="goBack">{{
          $t("generic.btnBack")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div v-if="help">
          <b-card class="mb-3">
            <b-card-title>{{ help.title }} <span v-if="organization && organization.superUser"><span
                  v-if="help.urlRef">({{ help.urlRef }})</span></span></b-card-title>
            <div v-html="modifyUrVideosYoutube(help.content)"></div>
          </b-card>
        </div>
        <div v-else>No hay ayuda</div>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import HelpsComponent from '../../components/helps/HelpsComponent';

import utilsService from "../../services/utils";
import helpService from "../../services/help";
import organizationService from "../../services/organization";

export default {
  name: "Help",
  mounted() {
    xray.index();
    this.getHelp();
    this.getOrganization();

    //utilsService.auditActivity({ action: "VIEW", module: "HELP", info: "" });
  },
  watch: {
  },
  computed: {
  },
  methods: {
    modifyUrVideosYoutube(url) {
      let endpoint = url;
      endpoint = endpoint.replace('data-oembed-url', "class='w-100 h-100' data-iframe-src");
      return endpoint;
    },
    async getOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response) {
            this.organization = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-organization-preferences",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId
            }),
          });
        },
        " "
      );
    },
    goBack() {
      this.$router.go(-1);
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getHelp() {

      let self = this;

      if (
        this.$route.query.id !== undefined) {

        this.$awn.asyncBlock(
          helpService.get(this.$route.query.id
          ),
          (response) => {
            if (response) {
              self.help = response.data;
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "helpService.getAll",
              module: "view-pages-professional-contact-contacts",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                page: this.pagination.page - 1,
                itemsPerPage: this.pagination.itemsPerPage,
                data: data
              })
            });
          },
          " "
        );
      }

    },
  },
  data() {
    return {
      organization: undefined,
      help: undefined,
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },

  components: {
    DatePicker,
    Multiselect
  },
};
</script>
